import {SVGProps} from 'react';

interface MoreVerticalIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  className?: string;
}

export const MoreVerticalIcon = ({
  width = 16,
  height = 16,
  className,
  ...props
}: MoreVerticalIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  );
};
